export const categories = [
  {
    iconClass: 'bi-capsule',
    label: 'Medications',
    route: '/medications'
  },
  {
    iconClass: 'bi-diagram-3',
    label: 'Categories',
    route: '/categories'
  },
  {
    iconClass: 'bi-heart-pulse',
    label: 'Conditions',
    route: '/conditions'
  },
  {
    iconClass: 'bi-eyedropper',
    label: 'Therapies',
    route: '/therapies'
  },
  {
    iconClass: 'bi-emoji-dizzy',
    label: 'Side Effects',
    route: '/side_effects'
  },
  {
    iconClass: 'bi-thermometer-half',
    label: 'Symptoms',
    route: '/symptoms'
  }
]

export const profileDropdownItems = [
  {
    iconClass: 'bi-person',
    label: 'My profile',
    route: '/profile'
  },
  {
    iconClass: 'bi-list-ul',
    label: 'Start Survey',
    route: '/survey/identified'
  },
  {
    iconClass: 'bi-gear',
    label: 'Settings',
    route: '/settings'
  },
  {
    iconClass: 'bi-lock',
    label: 'Admin',
    route: '/admin',
    userTypes: ['moderator', 'admin']
  },
  {
    isDivider: true
  },
  {
    iconClass: 'bi-box-arrow-left',
    label: 'Sign out',
    route: '/logout',
    iconRightClass: 'bi-arrow-right ms-auto'
  }
]
